import { GridModel, GridPostParams } from "common/models/utility-models/list-utility.model";
import { GroupsModel } from "./groups-model";

export class GroupsGridModel extends GroupsModel { }

export class GroupsListingModel extends GridModel<GroupsGridModel> {
    checkBoxEmitArray: any = [];
 }

export class GroupsGridPostParams extends GridPostParams {
    pageNumber: 1;
    pageSize: 10;
    searchText: '';
    direction: '';
    column: ''
}